// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CQPN","title":"styles_title__2xhw1"};